'use client';

import { AppProvider } from '@shopify/polaris';
import en from '@shopify/polaris/locales/en.json';

import '@shopify/polaris/build/esm/styles.css';

export const PolarisModalProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => <AppProvider i18n={en}>{children}</AppProvider>;
